import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import TabButtonGroup from '../../Components/Tabs/TabButtonGroup'
import TabButton from '../../Components/Tabs/TabButton'
import Tab from '../../Components/Tabs/Tab';
import TabGroup from '../../Components/Tabs/TabGroup'
import OrderCard from "../../Components/OrderCard"
import axios from 'axios'
import emptyOrder from '../../Assets/Images/Empty-rafiki.svg'
import { useTranslation } from "react-i18next"

const Orders = () => {

    const [orderList, setOrderList] = useState([])
    const [tab, setTab] = useState(0)
    const [statusList, setStatusList] = useState([])
    const [loading, setLoading] = useState(true)
    const { t } = useTranslation()


    useEffect(() => {
        axios.all([API.get('/order/getOrderList'), API.get('/order/getOrderStatus')]).then(axios.spread((listRes, statRes) => {
            setOrderList(listRes.data.data)
            setStatusList(statRes.data.data)
            setLoading(false)
        }))
    }, [])

    return (
        <>
            {
                loading ? t("Loading please wait") : orderList && orderList.length > 0 && statusList && statusList.length > 0 ? <motion.div className="relative w-full h-full flex flex-col px-20">
                    <motion.div className="text-black font-bold text-md">
                        {t('Your Orders')}
                    </motion.div>
                    <motion.div className="flex flex-row justify-between w-full">
                        <motion.div className="items-center justify-center flex flex-row my-5">
                            <TabButtonGroup injectClass={'bg-slate-200'}>
                                <TabButton injectClass={'bg-primeColor/20 '} index={0} value={tab} setValue={setTab} id={'Orders'}>
                                    {t('Orders')}
                                </TabButton>
                                <TabButton index={1} injectClass={'bg-primeColor/20 '} value={tab} setValue={setTab} id={'Cancelled Orders`'}>
                                    {t('Cancelled Orders')}
                                </TabButton>
                            </TabButtonGroup>
                        </motion.div>
                    </motion.div>
                    <TabGroup value={tab}>
                        <Tab index={0} value={tab}>
                            <OrderCard list={orderList} status={statusList} />
                        </Tab>
                        <Tab index={1} value={tab}>
                            {t('Cancelled')}
                        </Tab>
                    </TabGroup>
                </motion.div> : <motion.div className="w-full h-full flex flex-col items-center justify-center">
                    <img src={emptyOrder} width={500} height={500} />
                    <motion.div className="text-[#002557] font-bold text-xl">{t('No Orders')}</motion.div>
                </motion.div>
            }
        </>
    )
}

export default Orders